import { BaseService } from '#services/BaseService';
import { http } from '#utils/axios';

class ProviderService extends BaseService {
  getOptionsList = (params) => {
    return http({
      params,
      url: `${this.endpoint}/`
    }).then(({ data }) => ({
      next: data.next,
      result: data.result?.map((el) => {
        return {
          label: el.name,
          value: el.id
        };
      })
    }));
  };

  constructor() {
    super('/provider');

    if (!ProviderService.instance) {
      ProviderService.instance = this;
    }
    return ProviderService.instance;
  }
}

const instance = new ProviderService();
Object.freeze(instance);

export default instance;
